export const grads = [
    'linear-gradient(to top, #5ee7df 0%, #b490ca 100%)',
    'linear-gradient(to right, #06beb6, #48b1bf)',
    'linear-gradient(120deg, #e0c3fc 0%, #8ec5fc 100%)',
    'linear-gradient(to right, rgb(127, 127, 213), rgb(134, 168, 231), rgb(145, 234, 228))',
    'linear-gradient(120deg, #f093fb 0%, #f5576c 100%)',
    'linear-gradient(to right, rgb(238, 9, 121), rgb(255, 106, 0))'
];

export const themeParams = [
    {
        themeType: 'dark',
        sceneBackgroundClass: 'p-2 bg-space-black',
        navBarClass: 'navbar navbar-expand navbar-dark bg-space-black',
        insertButtonClass: 'btn btn-sm opal-outline-emerald mr-2',
        eraseButtonClass: 'btn btn-sm sunset-outline-orange mr-2',
        findButtonClass: 'btn btn-sm ocean-outline-zircon mr-2',
        clearButtonClass: 'btn btn-sm purple-outline-dawn mr-2',
        undoButtonClass: 'btn btn-sm btn-outline-warning mr-2',
        redoButtonClass: 'btn btn-sm btn-outline-warning',
        inputClass: 'form-control form-control-sm mx-1 w-25 text-input-space-black',
        mobileInputClass: 'form-control form-control-sm text-input-space-black'
    },
    {
        themeType: 'light',
        sceneBackgroundClass: 'p-2 bg-soap-bubble',
        navBarClass: 'navbar navbar-expand navbar-light bg-soap-bubble',
        insertButtonClass: 'btn btn-sm btn-success mr-2',
        eraseButtonClass: 'btn btn-sm btn-danger mr-2',
        findButtonClass: 'btn btn-sm btn-info mr-2',
        clearButtonClass: 'btn btn-sm btn-secondary mr-2',
        undoButtonClass: 'btn btn-sm btn-warning mr-2',
        redoButtonClass: 'btn btn-sm btn-warning',
        inputClass: 'form-control form-control-sm mx-1 w-25',
        mobileInputClass: 'form-control form-control-sm'
    },
    {
        themeType: 'dark',
        sceneBackgroundClass: 'p-2 bg-deep-ocean',
        navBarClass: 'navbar navbar-expand navbar-dark bg-deep-ocean',
        insertButtonClass: 'btn btn-sm mild-sky mr-2',
        eraseButtonClass: 'btn btn-sm tender-rose mr-2',
        findButtonClass: 'btn btn-sm blue-sky mr-2',
        clearButtonClass: 'btn btn-sm cosmic-fusion mr-2',
        undoButtonClass: 'btn btn-sm flare-orange mr-2',
        redoButtonClass: 'btn btn-sm flare-orange-reverse',
        inputClass: 'form-control form-control-sm mx-1 w-25',
        mobileInputClass: 'form-control form-control-sm'
    },
    {
        themeType: 'dark',
        sceneBackgroundClass: 'p-2 bg-grey-phantom',
        navBarClass: 'navbar navbar-expand navbar-light bg-light',
        insertButtonClass: 'btn btn-sm fresh-grass mr-2',
        eraseButtonClass: 'btn btn-sm georgian-blood mr-2',
        findButtonClass: 'btn btn-sm confused-ocean mr-2',
        clearButtonClass: 'btn btn-sm cloudy-sky mr-2',
        undoButtonClass: 'btn btn-sm sun-core mr-2',
        redoButtonClass: 'btn btn-sm sun-core',
        inputClass: 'form-control form-control-sm mx-1 w-25',
        mobileInputClass: 'form-control form-control-sm'
    },
    {
        themeType: 'light',
        sceneBackgroundClass: 'p-2 bg-light',
        navBarClass: 'navbar navbar-expand navbar-light bg-light',
        insertButtonClass: 'btn btn-sm btn-outline-success mr-2',
        eraseButtonClass: 'btn btn-sm btn-outline-danger mr-2',
        findButtonClass: 'btn btn-sm btn-outline-info mr-2',
        clearButtonClass: 'btn btn-sm btn-outline-secondary mr-2',
        undoButtonClass: 'btn btn-sm btn-outline-warning text-dark mr-2',
        redoButtonClass: 'btn btn-sm btn-outline-warning text-dark',
        inputClass: 'form-control form-control-sm mx-1 w-25',
        mobileInputClass: 'form-control form-control-sm'
    },
    {
        themeType: 'dark',
        sceneBackgroundClass: 'p-2 bg-midnight',
        navBarClass: 'navbar navbar-expand navbar-dark bg-midnight',
        insertButtonClass: 'btn btn-sm green-laser mr-2',
        eraseButtonClass: 'btn btn-sm red-laser mr-2',
        findButtonClass: 'btn btn-sm blue-laser mr-2',
        clearButtonClass: 'btn btn-sm purple-laser mr-2',
        undoButtonClass: 'btn btn-sm fire-laser mr-2',
        redoButtonClass: 'btn btn-sm fire-laser',
        inputClass: 'form-control form-control-sm text-input-underlined ml-1 mr-2 w-25',
        mobileInputClass: 'form-control form-control-sm text-input-underlined'
    }
];

export const nodeParams = [
    {
        nodeBorderRadius: '6.5px'
    },
    {
        nodeBorderRadius: '3.5px'
    },
    {
        nodeBorderRadius: '3px'
    },
    {
        nodeBorderRadius: '0%'
    },
    {
        nodeBorderRadius: '0%'
    },
    {
        nodeBorderRadius: '8px'
    }
];

export const elementParams = [
    {
        background: 'rgba(0, 0, 0, 0) linear-gradient(-225deg, rgba(227, 253, 245, 0.32) 0%, ' +
            'rgba(255, 230, 250, 0.79) 100%) repeat scroll 0% 0%',
    },
    {
        background: 'rgba(0, 0, 0, 0) linear-gradient(-225deg, rgba(227, 253, 245, 0.32) 0%, ' +
            'rgba(255, 230, 250, 0.79) 100%) repeat scroll 0% 0%',
    },
    {
        background: 'transparent',
        fontSize: '1.1rem',
        fontWeight: '600',
        color: 'rgb(0, 3, 9)'
    },
    {
        background: 'rgba(0, 0, 0, 0) linear-gradient(-225deg, rgba(227, 253, 245, 0.32) 0%, ' +
            'rgba(255, 230, 250, 0.79) 100%) repeat scroll 0% 0%',
    },
    {
        background: 'rgba(0, 0, 0, 0) linear-gradient(-225deg, rgba(227, 253, 245, 0.32) 0%, ' +
            'rgba(255, 230, 250, 0.79) 100%) repeat scroll 0% 0%',
    },
    {
        background: 'rgba(0, 0, 0, 0) linear-gradient(-225deg, rgba(227, 253, 245, 0.32) 0%, ' +
            'rgba(255, 230, 250, 0.79) 100%) repeat scroll 0% 0%',
    }
];

export const themeNames = [
    'Andromeda',
    'Pacific',
    'North Sea Sunset',
    'Fluctuation',
    'General',
    'Sweet Midnight'
];

export const setXById: { [key in string]?: (x: number) => void } = {};